import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { ACCOUNT, MARKETPLACE } = ANALYTICS_CATEGORIES;
const { CLICK } = SNOWPLOW_EVENTS;

type BulkBuyingPromotionPageCategory = typeof MARKETPLACE.VEHICLE_LIST | typeof ACCOUNT.BIDDING_AND_PURCHASE_HISTORY;

export const triggerBulkBuyingPromotionModalOpened = (pageCategory: BulkBuyingPromotionPageCategory): void => {
	const eventPayload = getSnowplowEventPayload({
		category: pageCategory,
		name: 'dlr_bulk_buying_promotion_modal_opened',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});
	logAnalyticsEvent({ eventPayload });
};
